import * as ActionTypes from './actionTypes'

export function setStatePlayPrvOnNav(value, stateLocation) {
    return {
        type : ActionTypes.SET_STATE_TTS_PLAY_PRV_ON_NAV,
        payload: {
            stateLocation,
            value
        }
    }
}

export function setStateLastPrvUrl(value, stateLocation) {
    return {
        type : ActionTypes.SET_STATE_TTS_LAST_PRV_URL,
        payload: {
            stateLocation,
            value
        }
    }
}

export function setStateWasPlayed(value, stateLocation) {
    return {
        type : ActionTypes.SET_STATE_TTS_WAS_PLAYED,
        payload: {
            stateLocation,
            value
        }
    }
}

export function setStateShouldPlay(value, stateLocation) {
    return {
        type : ActionTypes.SET_STATE_TTS_SHOULD_PLAY,
        payload: {
            stateLocation,
            value
        }
    }
}

export function setStateSoundMonitorTimer(value, stateLocation) {
    return {
        type : ActionTypes.SET_STATE_TTS_SOUND_MONITOR_TIMER,
        payload: {
            stateLocation,
            value
        }
    }
}

export function setStateAudioPlayTimer(value, stateLocation) {
    return {
        type : ActionTypes.SET_STATE_TTS_AUDIO_PLAY_TIMER,
        payload: {
            stateLocation,
            value
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/response-handler-tts/src/actions/actions.js